function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#Database_svg__clip0_1818_35643)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M18.588 2.5c0-1.38-3.837-2.5-8.571-2.5S1.445 1.12 1.445 2.5 5.283 5 10.017 5c4.734 0 8.571-1.12 8.571-2.5z",
  fill: "#BDDBFF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.017 10c4.732 0 8.571-1.118 8.571-2.5v-5c0 1.382-3.84 2.5-8.571 2.5-4.732 0-8.572-1.118-8.572-2.5v5c0 1.382 3.84 2.5 8.572 2.5z",
  fill: "#9BC9FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.017 15c4.732 0 8.571-1.118 8.571-2.5v-5c0 1.382-3.84 2.5-8.571 2.5-4.732 0-8.572-1.118-8.572-2.5v5c0 1.382 3.84 2.5 8.572 2.5z",
  fill: "#57A4FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.588 12.5c0 1.382-3.84 2.5-8.571 2.5-4.732 0-8.572-1.118-8.572-2.5v5c0 1.382 3.84 2.5 8.572 2.5 4.732 0 8.571-1.118 8.571-2.5v-5z",
  fill: "#2488FF"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "Database_svg__clip0_1818_35643"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})));

function SvgDatabase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgDatabase;